export class StudentTagModel {
	entity_type: string;
	entity_id: number;
	id: number;
	tag: string;
}
